import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import asignIconWhite from '../assets/logos/asign-icon-white.svg';
import asignIconPrimary from '../assets/logos/asign-icon-primary.svg';
import '../styling/video-sidebar.css';

function TabSection({ children, videoUrl, videoUrls, videoLabels, sectionId = 'section', activeSectionId, setActiveSectionId, setCurrentVideoUrl, setVideoSidebarOpen, setVideoLabels, setSelectedVideoIndex, setAllVideoUrls, isDefault, registerSection, unregisterSection }) {
  const { i18n } = useTranslation();
  // Default to LSQ (index 1) on French pages, ASL (index 0) on English pages
  const localSelectedIndex = i18n.language === 'fr' ? 1 : 0;
  const wrapperRef = useRef(null);

  // Support both single videoUrl and multiple videoUrls
  const videos = videoUrls || (videoUrl ? [videoUrl] : []);
  const labels = videoLabels || videos.map((_, i) => `V${i + 1}`);
  const currentVideo = videos[localSelectedIndex] || videoUrl;

  // Register this section for navigation. getEl is read at scroll time so
  // it always returns the live DOM node, even though we register only once.
  useEffect(() => {
    if (registerSection) {
      registerSection({ sectionId, videos, labels, isDefault: !!isDefault, getEl: () => wrapperRef.current });
    }
    return () => {
      if (unregisterSection) unregisterSection(sectionId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionId, registerSection, unregisterSection]);

  const toggleVideoSidebar = () => {
    if (activeSectionId === sectionId) {
      setActiveSectionId(null);
      setVideoSidebarOpen(false);
    } else {
      setActiveSectionId(sectionId);
      setCurrentVideoUrl(currentVideo);
      setVideoSidebarOpen(true);
      // Pass video info to App
      if (setAllVideoUrls) setAllVideoUrls(videos);
      if (setVideoLabels) setVideoLabels(labels);
      if (setSelectedVideoIndex) setSelectedVideoIndex(localSelectedIndex);
    }
  };

  const isActive = activeSectionId === sectionId;

  useEffect(() => {
    if (isActive) {
      setCurrentVideoUrl(currentVideo);
    }
  }, [isActive, currentVideo, setCurrentVideoUrl]);

  return (
    <div className="tab-section-wrapper" ref={wrapperRef}>
      {/* Left Tab Button */}
      
      <div 
      className={`tab-section-left-tab ${isActive ? 'active' : ''}`} 
      onClick={toggleVideoSidebar} 
      title="View video" 
      style={{ background: isActive ? 'var(--color-primary)' : 'var(--color-secondary)' }}>

        {/* ICON GO HERE */}
        <img src={isActive ? asignIconWhite : asignIconPrimary} alt="ASL Icon" className="tab-section-icon" />

      </div>

      {/* Original Tab Section */}
      <section className={`tab-section ${isActive ? 'active' : ''}`}>
        {children}
      </section>
    </div>
  );
}

export default TabSection;
